import _ from 'lodash';

/**
 * @name AppointmentController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} $rootScope Unknown
 * @param {Unknown} $state Unknown
 * @param {Unknown} $uibModal Unknown
 * @param {Unknown} Appointment Unknown
 * @param {Unknown} Project Unknown
 * @param {Unknown} Activity The activity service
 * @param {Unknown} AlertMessages Unknown
 * @param {Unknown} RESPONSE_MESSAGES Unknown
 * @param {Unknown} Session Unknown
 * @param {Unknown} NOTIFICATIONS Unknown
 * @param {Unknown} Notification Unknown
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 * @param {constant} STATUS_IDS The STATUS_IDS constant
 * @param {service} Shop The Shop service
 * @param {service} Operators The Operators service
 * @param {service} MessageTemplates The MessageTemplates service
 * @param {library} $log The Angular $log service
 */
function AppointmentController(
  $rootScope,
  $state,
  $uibModal,
  Appointment,
  Project,
  Activity,
  AlertMessages,
  RESPONSE_MESSAGES,
  Session,
  NOTIFICATIONS,
  Notification,
  collectorWantsNotif,
  STATUS_IDS,
  Shop,
  Operators,
  MessageTemplates,
  $log
) {
  let vm = this;
  vm.$onInit = function() {
    // Defaults
    vm.status = {
      editOwner: false,
      editPrice: false
    };
    vm.price = vm.currentAppointment.paymentData.price;
    vm.isArchiveConfirmCollapsed = true;

    // Defaults
    vm.session = Session;
    vm.STATUS_IDS = STATUS_IDS;

    // Public methods
    vm.resetPrice = resetPrice;
    vm.updatePrice = updatePrice;
    vm.updateOperator = updateOperator;
    vm.confirmAppointment = confirmAppointment;
    vm.selectAppointment = selectAppointment;
    vm.updateAppointment = updateAppointment;
    vm.addRelatedAppointment = addRelatedAppointment;
    vm.declineRequest = declineRequest;
    vm.cancelAppointment = cancelAppointment;
    vm.completeAppointment = completeAppointment;
    vm.updatePayment = updatePayment;
    vm.openAppointmentResponseModal = openAppointmentResponseModal;
    vm.openDepositModal = openDepositModal;
    vm.archiveAppointment = archiveAppointment;
    vm.readMessageTemplate = readMessageTemplate;

    // If an operator is logged in, get the operators for the shop
    if (Session.activeState.role === 'operator') {
      const shopId = Session.activeState.association.shop.id;
      getOperators(shopId);
      vm.canUpdateAppts = true;
    }

    // If an artist is logged in, get the artist's appointment permissions
    if (Session.activeState.role === 'artist') {
      vm.canUpdateAppts = Session.activeState.association.can_update_appts;
    }
  };

  /**
   * @name getOperators
   * @description Get shop operators
   * @param {number} shopId The ID of the shop
   */
  function getOperators(shopId) {
    Operators.getAllForShop(shopId).then(function(operators) {
      vm.operators = operators;
    });
  }

  /**
   * @name selectAppointment
   * @description Function to load a related appointment/session
   * @param {number} appointmentId The appointment ID to load
   */
  function selectAppointment(appointmentId) {
    $state.go('.', {appointment_id: appointmentId});
  }

  /**
   * @name updateAppointment
   * @description Function to call the update appointment modalInstance
   */
  function updateAppointment() {
    let modalInstance = $uibModal.open({
      template: require('./update/update.template.html'),
      animation: true,
      controller: 'UpdateAppointmentController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        updateAppointmentsData(appointment);

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name openAppointmentResponseModal
   * @description Function to open the collector response modal.
   * @param {object} appointment The selected appointment.
   */
  function openAppointmentResponseModal(appointment) {
    let modalInstance = $uibModal.open({
      template: require('./respond/respond.template.html'),
      animation: true,
      controller: 'RespondAppointmentController',
      controllerAs: '$ctrl',
      resolve: {
        appointment: function() {
          return appointment;
        },
        project: function() {
          return vm.project;
        },
        shopMessageTemplates: function(Shop, MessageTemplates) {
          return Shop.get(vm.currentAppointment.shop.id).then(function(shop) {
            return MessageTemplates.get(shop.message_templates).then(function(
              messageTemplates
            ) {
              return messageTemplates;
            });
          });
        }
      }
    });
    modalInstance.result.then(
      function(updatedAppointment) {
        updateAppointmentsData(updatedAppointment);
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name openDepositModal
   * @description Function to open the collector deposit payment modal.
   * @param {object} appointment The selected appointment.
   */
  function openDepositModal() {
    let modalInstance = $uibModal.open({
      template: require('./deposit/deposit.template.html'),
      animation: true,
      controller: 'CollectorDepositController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(
      function() {},
      function() {
        // No error handling needed.
      }
    );
  }

  /**
  * @name archiveAppointment
  * @description Function to archive an appointment.
  * @param {object} appointment The appointment to archive.
  */
  function archiveAppointment() {
    let modalInstance = $uibModal.open({
      template: require('./archive/archive.template.html'),
      animation: true,
      controller: 'ArchiveAppointmentController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        updateAppointmentsData(appointment);

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.archived,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name addRelatedAppointment
   * @description Function to call the add related appointment modalInstance
   */
  function addRelatedAppointment() {
    let modalInstance = $uibModal.open({
      template: require('./add-related/add.related.template.html'),
      animation: true,
      controller: 'AddRelatedController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        // Get the appointment shop again
        Shop.get(appointment.shop).then(function(response) {
          appointment.shop = response;

          // Get the shop's message tempaltes
          MessageTemplates.get(
            appointment.shop.message_templates
          ).then(function(response) {
            appointment.shop.messageTemplates = response;
          });
        });

        vm.appointments.push(appointment);
        selectAppointment(appointment.id);

        // Update the appointment on the parent component
        vm.onAppointmentChange({appointment: appointment});

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name declineRequest
   * @descriptoin Function to call the decline request modalInstance
   */
  function declineRequest() {
    let modalInstance = $uibModal.open({
      template: require('./decline/decline.template.html'),
      animation: true,
      controller: 'DeclineAppointmentController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        updateAppointmentsData(appointment);

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name confirmAppointment
   * @description Function to open the confirm appointment modal.
   */
  function confirmAppointment() {
    let modalInstance = $uibModal.open({
      template: require('./confirm/confirm.template.html'),
      animation: true,
      controller: 'ConfirmAppointmentController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        },
        shopMessageTemplates: function(Shop, MessageTemplates) {
          return Shop.get(vm.currentAppointment.shop.id).then(function(shop) {
            return MessageTemplates.get(shop.message_templates).then(function(
              messageTemplates
            ) {
              return messageTemplates;
            });
          });
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        updateAppointmentsData(appointment);

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name cancelAppointment
   * @descriptoin Function to call the cancel appointment modalInstance
   */
  function cancelAppointment() {
    let modalInstance = $uibModal.open({
      template: require('./cancel/cancel.template.html'),
      animation: true,
      controller: 'CancelAppointmentController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        updateAppointmentsData(appointment);

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name completeAppointment
   * @description Function to open the complete appointment modalInstance.
   */
  function completeAppointment() {
    let modalInstance = $uibModal.open({
      template: require('./complete/complete.template.html'),
      animation: true,
      controller: 'CompleteAppointmentController as $ctrl',
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        },
        shopMessageTemplates: function(Shop, MessageTemplates) {
          return Shop.get(vm.currentAppointment.shop.id).then(function(shop) {
            return MessageTemplates.get(shop.message_templates).then(function(
              messageTemplates
            ) {
              return messageTemplates;
            });
          });
        }
      }
    });
    modalInstance.result.then(
      function(appointment) {
        updateAppointmentsData(appointment);

        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name updatePayment
   * @description Function to call the update payment modalInstance.
   */
  function updatePayment() {
    let modalInstance = $uibModal.open({
      template: require('./payments/payments.template.html'),
      animation: true,
      controller: 'PaymentsController as $ctrl',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        appointment: function() {
          return vm.currentAppointment;
        },
        project: function() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(
      function(results) {
        if (!_.isUndefined(results.parsedPayments)) {
          vm.currentAppointment.paymentData = results.parsedPayments;
        }
        if (!_.isUndefined(results.message)) {
          let conversationId = vm.currentAppointment.conversations;
          let projectId;
          let appointmentId = vm.currentAppointment.id;
          $rootScope.$broadcast(
            'merge-activity',
            conversationId,
            appointmentId,
            projectId
          );
        }
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.saved,
          type: 'success'
        });
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name readMessageTemplate
   * @description Function to open a modal to display a message template
   * @param {string} messageTitle The title of the template
   * @param {string} messageTemplate The message template
   */
  function readMessageTemplate(messageTitle, messageTemplate) {
    let modalInstance = $uibModal.open({
      template: require('./read-message-templates/read-message-templates.template.html'),
      animation: true,
      controller: 'ReadMessageTemplateController as $ctrl',
      resolve: {
        messageTitle: function() {
          return messageTitle;
        },
        messageTemplate: function() {
          return messageTemplate;
        }
      }
    });
    modalInstance.result.then(function() {
      // Nothing to do
    });
  }

  /**
  * @name updatePrice
  * @description Function to update the price of an appointment
  * @param {string} price The new price of the appointment
  */
  function updatePrice(price) {
    let newPrice = parseFloat(price);

    // Invalid Price
    if (newPrice <= 0 || !newPrice) {
      AlertMessages.add({
        msg: 'Total Price cannot be negative, blank or zero.',
        type: 'danger'
      });
      vm.status.editPrice = false;
    } else {
      // Valid price. Update appointment with new price
      Appointment.update({
        id: vm.currentAppointment.id,
        price: newPrice
      }).then(
        function(appointment) {
          vm.status.editPrice = false;
          vm.price = appointment.price.toString();
          updateAppointmentsData(appointment);
        },
        function() {
          AlertMessages.add({
            msg: RESPONSE_MESSAGES.paymentUpdateError,
            type: 'danger'
          });
        }
      );
    }
  }

  /**
   * @name resetPrice
   * @description Function to reset the price of an appointment.
   */
  function resetPrice() {
    vm.price = vm.currentAppointment.price;
    vm.status.editPrice = false;
  }

  /**
   * @name updateOperator
   * @description Function to update the operator assigned to an appointment
   * @param {object} operator The operator to assign to the appointment.
   */
  function updateOperator(operator) {
    let updatedAppointment = _.cloneDeep(vm.currentAppointment);
    updatedAppointment.managed_by = operator;
    Appointment.update(updatedAppointment).then(function(appointment) {
      vm.status.editOwner = false;
      updateAppointmentsData(appointment);
    });
  }

  /**
   * @name updateAppointmentsData
   * @description Function to update the current appointent and  array of
   * appointments that build. The appointment sessions tabs after one of the
   * appointments listed is updated
   * @param {object} appointment The appointment to be inserted into the array
   */
  function updateAppointmentsData(appointment) {
    // Update the current appointment
    vm.currentAppointment = appointment;

    // Get the appointment shop again TODO Refactor the shop to a different data
    // structure to avoid making this call in the future
    Shop.get(vm.currentAppointment.shop).then(function(response) {
      vm.currentAppointment.shop = response;

      // Get the shop's message tempaltes
      MessageTemplates.get(appointment.shop.message_templates).then(function(
        response
      ) {
        appointment.shop.messageTemplates = response;
      });

      // Update the current appointment on the parent component
      vm.onAppointmentChange({appointment: appointment});
    });

    // Update appointment activity
    let conversationId = vm.currentAppointment.conversations;
    let projectId;
    $rootScope.$broadcast(
      'merge-activity',
      conversationId,
      vm.currentAppointment.id,
      projectId
    );
  }
}

angular
  .module('inkfinder')
  .controller('AppointmentController', AppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/appointment.controller.js